const menuCategory = [
  'all',
  'edible',
  'extract',
  'featured',
  'flower',
  'gear',
  'grow',
  'jane-gold',
  'merch',
  'pre-roll',
  'specials',
  'tincture',
  'topical',
  'vape',
] as const;

export type MenuCategory = (typeof menuCategory)[number];

export const isMenuCategory = (str: string): str is MenuCategory => {
  return menuCategory.includes(str as MenuCategory);
};
